<mat-card class="cityDetails-Label">
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{'dashboardBizzDev.overview.kpis.title.fullLabel' | translate}}
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="table-height">
        <section>
            <table mat-table [dataSource]="dataSource"
                   matSort matSortActive="fullLabel" matSortDirection="asc" matSortDisableClear
                   class="tab-content"
                   multiTemplateDataRows>
                <!-- City Column -->
                <ng-container matColumnDef="fullLabel">
                    <tr>
                        <th class="labelTextHeader" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dashboardBizzDev.overview.kpis.rightPanel.table.city.fullLabel' | translate}}
                        </th>
                    </tr>
                    <tr>
                        <td class="labelButton" mat-cell *matCellDef="let element"
                            (click)="loadCityDetails(element.id)">
                            {{element.fullLabel}}
                        </td>
                    </tr>
                </ng-container>

                <!-- ImportComparison -->
                <ng-container matColumnDef="importComparison">
                    <tr>
                        <th class="labelNumberHeader" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dashboardBizzDev.overview.kpis.rightPanel.table.import.fullLabel' | translate}}
                        </th>
                    </tr>
                    <tr>
                        <td class="labelRowNumber" mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.importComparison; else comparisonOK">
                                <p [ngStyle]="{'color' : 'red', 'text-align' : 'center' }">
                                    <mat-icon>error</mat-icon>
                                </p>
                            </ng-container>
                            <ng-template #comparisonOK>
                                <p [ngStyle]="{'color' : 'green', 'text-align' : 'center' }">
                                    <mat-icon>done</mat-icon>
                                </p>
                            </ng-template>
                        </td>
                    </tr>
                </ng-container>
                <!-- Missing Realized Column -->
                <ng-container matColumnDef="missingRealized">
                    <tr>
                        <th class="labelNumberHeader" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dashboardBizzDev.overview.kpis.rightPanel.table.missingRealized.fullLabel' | translate}}
                        </th>
                    </tr>
                    <tr>
                        <td class="labelRowNumber" mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.missingRealized; else missingRealizedOK">
                                <p [ngStyle]="{'color' : 'red', 'text-align' : 'center' }">
                                    <mat-icon>error</mat-icon>
                                </p>
                            </ng-container>
                            <ng-template #missingRealizedOK>
                                <p [ngStyle]="{'color' : 'green', 'text-align' : 'center' }">
                                    <mat-icon>done</mat-icon>
                                </p>
                            </ng-template>
                        </td>
                    </tr>
                </ng-container>
                <!-- RealizedNotValid Column -->
                <ng-container matColumnDef="realizedNotValid">
                    <tr>
                        <th class="labelNumberHeader" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dashboardBizzDev.overview.kpis.rightPanel.table.realizedNotValid.fullLabel' | translate}}
                        </th>
                    </tr>
                    <tr>
                        <td class="labelRowNumber" mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.realizedNotValid; else RealizedValid">
                                <p [ngStyle]="{'color' : 'red', 'text-align' : 'center' }">
                                    <mat-icon>error</mat-icon>
                                </p>
                            </ng-container>
                            <ng-template #RealizedValid>
                                <p [ngStyle]="{'color' : 'green', 'text-align' : 'center' }">
                                    <mat-icon>done</mat-icon>
                                </p>
                            </ng-template>
                        </td>
                    </tr>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
            </table>
        </section>
    </mat-card-content>
</mat-card>



